"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUser = exports.CreateUser = exports.ResetPassword = exports.DeleteUser = exports.UserList = exports.User = exports.UserData = void 0;
const swagger_proxy_1 = require("./swagger-proxy");
const class_transformer_proxy_1 = require("./class-transformer-proxy");
const class_validator_proxy_1 = require("./class-validator-proxy");
class UserData {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "User's given (first) name",
        example: "John",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], UserData.prototype, "givenName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "User's family (last) name",
        example: "Doe",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], UserData.prototype, "familyName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "User's email address",
        example: "john.doe@example.com",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], UserData.prototype, "emailAddress", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Array of role IDs assigned to the user",
        example: ["admin", "user"],
        type: [String],
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], UserData.prototype, "roles", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether this user is backed by the Username-Password-Authentication (Auth0 database) connection, as opposed to an SSO/enterprise connection. Populated by the server on read; ignored on write. SSO-backed users' email/given name/family name are managed by their identity provider and cannot be edited here.",
        example: true,
        type: Boolean,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UserData.prototype, "isAuth0Backed", void 0);
exports.UserData = UserData;
class User {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "User profile data",
        type: UserData,
    }),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => UserData),
    __metadata("design:type", UserData)
], User.prototype, "data", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unique user identifier",
        example: "auth0|507f1f77bcf86cd799439011",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], User.prototype, "id", void 0);
exports.User = User;
class UserList {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Array of users in the organization",
        type: [User],
    }),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => User),
    __metadata("design:type", Array)
], UserList.prototype, "users", void 0);
exports.UserList = UserList;
class DeleteUser {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "ID of the user to delete",
        example: "auth0|507f1f77bcf86cd799439011",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], DeleteUser.prototype, "id", void 0);
exports.DeleteUser = DeleteUser;
class ResetPassword {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Email address of the user to reset password for",
        example: "john.doe@example.com",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ResetPassword.prototype, "email", void 0);
exports.ResetPassword = ResetPassword;
class CreateUser {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "User data for the new user",
        type: UserData,
    }),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => UserData),
    __metadata("design:type", UserData)
], CreateUser.prototype, "data", void 0);
exports.CreateUser = CreateUser;
class UpdateUser {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "ID of the user to update",
        example: "auth0|507f1f77bcf86cd799439011",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], UpdateUser.prototype, "id", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Updated user data",
        type: UserData,
    }),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => UserData),
    __metadata("design:type", UserData)
], UpdateUser.prototype, "data", void 0);
exports.UpdateUser = UpdateUser;
